export const TypeTemplates = [
  {
    id: 0,
    name: "banner_1_",
    keyword: "banner_1",
    logicWidth: 800.0,
    logicHeight: 2000.0,
    title: "Banner #1",
  },
  {
    id: 1,
    name: "banner_2_",
    keyword: "banner_2",
    logicWidth: 800.0,
    logicHeight: 2000.0,
    title: "Banner #2",
  },
  {
    id: 2,
    name: "poster_1_",
    keyword: "poster_1",
    logicWidth: 940.0,
    logicHeight: 1400.0,
    title: "Poster #1",
  },
  {
    id: 3,
    name: "poster_2_",
    keyword: "poster_2",
    logicWidth: 940.0,
    logicHeight: 1400.0,
    title: "Poster #2",
  },
  {
    id: 4,
    name: "thumbnail_1_",
    keyword: "thumbnail_1",
    logicWidth: 640.0,
    logicHeight: 360.0,
    title: "Thumbnail",
  },
  {
    id: 5,
    name: "logo_header_1_",
    keyword: "logo_header_1",
    logicWidth: 1600.0,
    logicHeight: 200.0,
    title: "Logo Header",
  },
  {
    id: 6,
    name: "logo_1_",
    keyword: "logo_1",
    logicWidth: 750.0,
    logicHeight: 500.0,
    title: "Logo",
  },
];
